import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {CategoriasMercado} from '../../components/MercadoSur/CategoriasMercado'

import {LocalesMercado} from '../../components/MercadoSur/LocalesMercado'
import {MercadoSurBanner} from '../../components/MercadoSur/MercadoSurBanner'

import './MercadoSur.css'

function MercadoSur() {
  const url = 'https://puntosurgdl.com/backend/'

  const [localesMercado, setLocalesMercado] = useState('')
  const [localMercado, setLocalMercado] = useState('')
  const [categories, setCategories] = useState('')
  const [category, setCategory] = useState('')

  const [showNewLocal, setShowNewLocal] = useState(false)
  const handleCloseNewLocal = () => setShowNewLocal(false)
  const handleShowNewLocal = () => setShowNewLocal(true)

  const [showEditLocal, setShowEditLocal] = useState(false)
  const handleCloseEditLocal = () => setShowEditLocal(false)
  const handleShowEditLocal = (localMercado) => {
    setLocalMercado(localMercado)
    setShowEditLocal(true)
  }
  const handleShowEditLocalAlt = () => setShowEditLocal(true)

  const [showDeleteLocal, setShowDeleteLocal] = useState(false)
  const handleCloseDeleteLocal = () => {
    setShowDeleteLocal(false)
    handleShowEditLocalAlt()
  }
  const handleCloseDeleteLocalAlt = () => setShowDeleteLocal(false)
  const handleShowDeleteLocal = () => {
    setShowDeleteLocal(true)
    handleCloseEditLocal()
  }

  const [showNewCategory, setShowNewCategory] = useState(false)
  const handleCloseNewCategory = () => setShowNewCategory(false)
  const handleShowNewCategory = () => setShowNewCategory(true)

  const [showEditCategory, setShowEditCategory] = useState(false)
  const handleCloseEditCategory = () => setShowEditCategory(false)
  const handleShowEditCategory = (category) => {
    setCategory(category)
    setShowEditCategory(true)
  }
  const handleShowEditCategoryAlt = () => setShowEditCategory(true)

  const [showDeleteCategory, setShowDeleteCategory] = useState(false)
  const handleCloseDeleteCategory = () => {
    setShowDeleteCategory(false)
    handleShowEditCategoryAlt()
  }
  const handleCloseDeleteCategoryAlt = () => setShowDeleteCategory(false)
  const handleShowDeleteCategory = () => {
    setShowDeleteCategory(true)
    handleCloseEditCategory()
  }

  useEffect(() => {
    getMercadoSur()
    getMercadoCategories()
  }, [])

  const getMercadoSur = () => {
    axios
      .get(url + 'getMercadoSur.php')
      .then((response) => {
        setLocalesMercado(response.data)
        console.log(localesMercado)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getMercadoCategories = () => {
    axios
      .get(url + 'getMercadoCategories.php')
      .then((response) => {
        setCategories(response.data)
        console.log(categories)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  let categoriesOption =
    categories.length > 0 ? (
      categories.map((category) => <option value={category.category}>{category.category}</option>)
    ) : (
      <option value={''}></option>
    )

  const uploadNewLocal = () => {
    const data = new FormData()

    data.append('id', '')
    data.append('nombre', document.getElementById('new-local-nombre').value)
    data.append('categoria', document.getElementById('new-local-categoria').value)
    data.append('nivel', document.getElementById('new-local-nivel').value)
    data.append('local', document.getElementById('new-local-local').value)
    data.append('telefono', document.getElementById('new-local-telefono').value)
    data.append('horario', document.getElementById('new-local-horario').value)
    data.append('metodopago', document.getElementById('new-local-metodopago').value)

    if (document.getElementById('new-local-logo').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-local-logo').files.length; i++) {
        data.append('file[]', document.getElementById('new-local-logo').files[i])
      }
      data.append('logoExists', true)
    }

    if (document.getElementById('new-local-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-local-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-local-img').files[i])
      }
      data.append('fondoExists', true)
    }

    axios
      .post(url + 'uploadNewLocal.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setLocalesMercado(res.data)
          handleCloseNewLocal()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const uploadLocal = () => {
    const data = new FormData()

    data.append('id', localMercado.id)
    data.append('nombre', document.getElementById('edit-local-nombre').value)
    data.append('categoria', document.getElementById('edit-local-categoria').value)
    data.append('nivel', document.getElementById('edit-local-nivel').value)
    data.append('local', document.getElementById('edit-local-local').value)
    data.append('telefono', document.getElementById('edit-local-telefono').value)
    data.append('horario', document.getElementById('edit-local-horario').value)
    data.append('metodopago', document.getElementById('edit-local-metodopago').value)

    if (document.getElementById('edit-local-logo').files.length !== 0) {
      for (let i = 0; i < document.getElementById('edit-local-logo').files.length; i++) {
        data.append('file[]', document.getElementById('edit-local-logo').files[i])
      }
      data.append('logoExists', true)
    }

    if (document.getElementById('edit-local-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('edit-local-img').files.length; i++) {
        data.append('file[]', document.getElementById('edit-local-img').files[i])
      }
      data.append('fondoExists', true)
    }

    axios
      .post(url + 'uploadNewLocal.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setLocalesMercado(res.data)
          handleCloseEditLocal()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteLocal = () => {
    const data = {
      id: localMercado.id,
    }

    axios
      .post(url + 'deleteLocal.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setLocalesMercado(res.data)
          handleCloseDeleteLocalAlt()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const uploadNewCategory = () => {
    const data = {
      id: '',
      category: document.getElementById('new-category-category').value,
    }

    axios
      .post(url + 'uploadNewCategory.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setCategories(res.data)
          handleCloseNewCategory()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const uploadCategory = () => {
    const data = {
      id: category.id,
      category: document.getElementById('edit-category-category').value,
    }

    axios
      .post(url + 'uploadNewCategory.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setCategories(res.data)
          handleCloseEditCategory()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteCategory = () => {
    const data = {
      id: category.id,
    }

    console.log(category.id)

    axios
      .post(url + 'deleteCategory.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setCategories(res.data)
          handleCloseDeleteCategoryAlt()
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='row g-5'>
      <MercadoSurBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Mercado Sur</h3>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-n12 mb-6'
                onClick={handleShowNewLocal}
              >
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body buscador-mercado'>
            <div className='cajas-locales'>
              <LocalesMercado localesMercado={localesMercado} editLocal={handleShowEditLocal} />
            </div>
          </div>
        </div>
      </div>

      <Modal show={showNewLocal} onHide={handleCloseNewLocal} className='modal-new-event'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar local Mercado Sur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Nombre:</label>
              <input type='text' className='form-control' id='new-local-nombre' />
            </div>
            <div className='form-group col-md-12'>
              <label>Categoría:</label>
              <select id='new-local-categoria' className='form-select'>
                {categoriesOption}
              </select>
            </div>
            <div className='form-group col-md-12'>
              <label>Nivel:</label>
              <select id='new-local-nivel' className='form-select'>
                <option value={`N1`}>N1</option>
              </select>
            </div>
            <div className='form-group col-md-12'>
              <label>Local:</label>
              <input type='text' className='form-control' id='new-local-local' />
            </div>
            <div className='form-group col-md-12'>
              <label>Teléfono:</label>
              <input type='text' className='form-control' id='new-local-telefono' />
            </div>
            <div className='form-group col-md-12'>
              <label>Horario:</label>
              <input type='text' className='form-control' id='new-local-horario' />
            </div>
            <div className='form-group col-md-12'>
              <label>Método de Pago:</label>
              <input type='text' className='form-control' id='new-local-metodopago' />
            </div>
            <div className='form-group col-md-12'>
              <label>Logo:</label>
              <input id='new-local-logo' type='file' className='form-control' />
            </div>
            <div className='form-group col-md-12'>
              <label>Imagen local:</label>
              <input id='new-local-img' type='file' className='form-control' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewLocal}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewLocal()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditLocal} onHide={handleCloseEditLocal} className='modal-edit-event'>
        <Modal.Header closeButton>
          <Modal.Title>Editar local Mercado Sur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Nombre:</label>
              <input
                type='text'
                className='form-control'
                id='edit-local-nombre'
                defaultValue={localMercado.nombre}
              />
            </div>
            <div className='form-group col-md-12'>
              <label>Categoría:</label>
              <select
                id='edit-local-categoria'
                className='form-select'
                defaultValue={localMercado.categoria}
              >
                {categoriesOption}
              </select>
            </div>
            <div className='form-group col-md-12'>
              <label>Nivel:</label>
              <select
                id='edit-local-nivel'
                className='form-select'
                defaultValue={localMercado.nivel}
              >
                <option value={`N1`}>N1</option>
              </select>
            </div>
            <div className='form-group col-md-12'>
              <label>Local:</label>
              <input
                type='text'
                className='form-control'
                id='edit-local-local'
                defaultValue={localMercado.local}
              />
            </div>
            <div className='form-group col-md-12'>
              <label>Teléfono:</label>
              <input
                type='text'
                className='form-control'
                id='edit-local-telefono'
                defaultValue={localMercado.telefono}
              />
            </div>
            <div className='form-group col-md-12'>
              <label>Horario:</label>
              <input
                type='text'
                className='form-control'
                id='edit-local-horario'
                defaultValue={localMercado.horario}
              />
            </div>
            <div className='form-group col-md-12'>
              <label>Método de Pago:</label>
              <input
                type='text'
                className='form-control'
                id='edit-local-metodopago'
                defaultValue={localMercado.metodoPago}
              />
            </div>
            <div className='form-group col-md-12 mb-10'>
              <label>Logo:</label>
              <img src={localMercado.logo} alt='' className={'w-20 rounded mb-10 mt-4'} />
              <br />
              <label>Cambiar Logo:</label>
              <input id='edit-local-logo' type='file' className='form-control' />
            </div>
            <div className='form-group col-md-12'>
              <label>Foto local:</label>
              <img src={localMercado.fondo} alt='' className={'w-100 rounded mb-10'} />
              <label>Cambiar foto local:</label>
              <input id='edit-local-img' type='file' className='form-control' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-danger btn-delete'
            onClick={handleShowDeleteLocal}
          >
            Eliminar
          </button>
          <button type='button' className='btn btn-secondary' onClick={handleCloseEditLocal}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadLocal()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteLocal} onHide={handleCloseDeleteLocal}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el local?</p>
          <p>Esta acción no puede deshacerse</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteLocal}>
            Cerrar
          </button>
          <button type='button' className='btn btn-danger' onClick={() => deleteLocal()}>
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Catálogo de categorías</h3>
            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-n12 mb-6'
                onClick={handleShowNewCategory}
              >
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body catalogo-categorias'>
            <div className='cajas-categorias'>
              <CategoriasMercado categories={categories} editCategory={handleShowEditCategory} />
            </div>
          </div>
        </div>
      </div>

      <Modal show={showNewCategory} onHide={handleCloseNewCategory} className='modal-new-event'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Nombre:</label>
              <input type='text' className='form-control' id='new-category-category' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewCategory}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewCategory()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditCategory} onHide={handleCloseEditCategory} className='modal-edit-event'>
        <Modal.Header closeButton>
          <Modal.Title>Editar local mercado sur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-12'>
              <label>Nombre:</label>
              <input
                type='text'
                className='form-control'
                id='edit-category-category'
                defaultValue={category.category}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-danger btn-delete'
            onClick={handleShowDeleteCategory}
          >
            Eliminar
          </button>
          <button type='button' className='btn btn-secondary' onClick={handleCloseEditCategory}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadCategory()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteCategory} onHide={handleCloseDeleteCategory}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el local?</p>
          <p>Esta acción no puede deshacerse</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteCategory}>
            Cerrar
          </button>
          <button type='button' className='btn btn-danger' onClick={() => deleteCategory()}>
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export {MercadoSur}
